import { IAddAgencyFormContent } from "./components/AddAgencyForm";
import { AlertConfigBuilder } from "shared/utils/alert-config-builder";

export interface ICancelAddingPopupContent {
  title: string;
  description: string;
  declineCancellationButton: string;
  approveCancellationButton: string;
}
export const ICancelAddingPopupContentKeys = [
  "title",
  "description",
  "declineCancellationButton",
  "approveCancellationButton",
];

export interface IAddAgencyPageContent {
  header: string;
  close: string;
  cancel: string;
  addAgency: string;
  formContent: IAddAgencyFormContent;
  cancelWarningDialog: ICancelAddingPopupContent;
}
export const IAddAgencyPageContentKeys = [
  "header",
  "close",
  "cancel",
  "addAgency",
  "formContent",
  "cancelWarningDialog",
];

declare type CancelDialogPopupSetting = {
  content: ICancelAddingPopupContent;
  continueCanceling: () => void;
};

export function getCancelDialogPopup(setting: CancelDialogPopupSetting) {
  const { content, continueCanceling } = setting;

  return new AlertConfigBuilder()
    .initBuildEntity()
    .setDefaultContent({
      title: content.title,
      description: content.description,
      closeButtonText: content.declineCancellationButton,
    })
    .setAlertProps({ icon: "notice" })
    .setCloseButton({ type: "secondary" })
    .addButton({
      type: "primary",
      click: continueCanceling,
      name: content.approveCancellationButton,
    })
    .build();
}
